/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plusonestotalcoming3Inputs */

const en_plusonestotalcoming3 = /** @type {(inputs: Plusonestotalcoming3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming in total`)
};

const de_plusonestotalcoming3 = /** @type {(inputs: Plusonestotalcoming3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommen insgesamt`)
};

/**
* | output |
* | --- |
* | "Coming in total" |
*
* @param {Plusonestotalcoming3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plusonestotalcoming3 = /** @type {((inputs?: Plusonestotalcoming3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plusonestotalcoming3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plusonestotalcoming3(inputs)
	return de_plusonestotalcoming3(inputs)
});
export { plusonestotalcoming3 as "plusOnesTotalComing" }